module.exports = __webpack_public_path__ + "static/media/TRIAL 2.4037c89d.mp3";